export default {
	"deviceManage": {
		"transfer": "โอน",
		"recycling": "รีไซเคิล",
		"chooseDeviceNumber": "เลือกหมายเลขอุปกรณ์",
		"deviceLibrary": "ไลบรารีของอุปกรณ์",
		"adminrole": "ผู้ดูแลระบบ",
		"platform": "แพลตฟอร์ม",
		"useMan": "ผู้ใช้",
		"stakeholders": "ผู้มีส่วนได้เสียปัจจุบัน",
		"department": "แผนก",
		"gpsTime": "เวลาติดตามล่าสุด",
		"offlineTime": "เวลาออฟไลน์",
		"equipmentStatus": "สถานะของอุปกรณ์",
		"dumpEnergy": "แบตเตอรี่คงเหลือ",
		"lat": "ติดตาม",
		"lng": "กรุณาเลือกที่อยู่",
		"deviceInfo": "ข้อมูลอุปกรณ์",
		"equipmentNo": "หมายเลขของอุปกรณ์",
		"equipmentCode": "บาร์โค้ดของอุปกรณ์",
		"cityName": "เมือง",
		"statusStartDt": "เวลาเริ่มต้นของสถานะ",
		"duration": "ระยะเวลา",
		"routeNos": "เอกสารการติดตามกระบวนการทำงานปัจจุบัน",
		"useHistory": "ประวัติการใช้",
		"type": "ประเภท",
		"addDeviceInfo": "เพิ่มอุปกรณ์การจัดการ",
		"transferAdmin": "โอนแก่ผู้ดูแลอุปกรณ์",
		"transferTakeholders": "ผู้ดูแลอุปกรณ์ ณ ปัจจุบัน",
		"equipmentLocation": "การกำหนดตำแหน่งอุปกรณ์",
		"importDevice": "นำเข้าอุปกรณ์",
		"tipsSelectManager": "กรุณาเลือกผู้ดูแลอุปกรณ์ ณ ปัจจุบัน",
		"tipsTransferSuccess": "การโอนสำเร็จ",
		"tipsCannotRecycle": "ไม่สามารถใช้งานอุปกรณ์ที่อยู่ในสถานะ \"กำลังใช้งาน\" ",
		"tipsSelectRecycle": "กรุณาเลือกรายการที่จะกู้คืน",
		"tipsConfirmRecycle": "ท่านแน่ใจว่าต้องการดำเนินการหรือไม่?"
	},
	"machine": {
		"mapMonitor": "การตรวจสอบแผนที่",
		"lastStateInfo": "ข้อมูลสถานะล่าสุด",
		"lastTime": "เวลาล่าสุด",
		"machineState": "สถานะการดำเนินงาน",
		"doorState": "สถานะของประตู",
		"conditioningState": "สถานะของเครื่องปรับอากาศ",
		"engineState": "สถานะของเครื่องยนต์",
		"speed": "ความเร็ว",
		"altitude": "ความสูง",
		"bearing": "ตำแหน่ง"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/machine/machine.js